import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cu_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  const t = localStorage.getItem("cu_token") || "";
  return `${API}/files/${path}?auth=${encodeURIComponent(t)}`;
}

export function qrUrl() {
  const t = localStorage.getItem("cu_token") || "";
  return `${API}/membership/qr.png?auth=${encodeURIComponent(t)}`;
}

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
